
import React, { useContext, useEffect, useState, useCallback } from "react";


import { FaEdit } from "react-icons/fa";
import { RiDeleteBin6Fill } from "react-icons/ri";



import { useTranslation } from "react-i18next";
import Pagination, { usePagination } from "../../../Components/CommonComponent/Pgination/pagination";
import api from "../../../services/api";
import LoadingSpinner from "../../../Components/CommonComponent/loadingSpiner/LoadingSpinner";
import CreateSubGroup from "../../TypesAndGroups/SubGroups/CreateSubGroup";
import CreateGroup from "../../TypesAndGroups/Groups/CreateGroup";
import DeleteDataModal from "../../../Components/CommonComponent/Modals/DeleteDataModal";
import AddButton from "../../../Components/CommonComponent/Button/AddButton";
import toast from "react-hot-toast";
import { CommonContext } from "../../../App";



export default function SubCategoryTable() {
  const { t } = useTranslation();
  const { branchId } = useContext(CommonContext);

  const [subGroups, setSubGroups] = useState({ allData: [], pagination: { totalRecords: 0 } });
  const [groups, setGroups] = useState({ allData: [], pagination: { totalRecords: 0 } });

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isGroupModalOpen, setIsGroupModalOpen] = useState(false);

  const [subGroupName, setSubGroupName] = useState("");
  const [subGroupNameInHindi, setSubGroupNameInHindi] = useState("");

  const [groupName, setGroupName] = useState("");
  const [groupNameInHindi, setGroupNameInHindi] = useState("");
  const [groupId, setGroupId] = useState("");
  const [groupType, setGroupType] = useState("");

  const [loading, setLoading] = useState(false);
  const [fetchDataLoading, setfetechDataLoading] = useState(false);

  const [subGroupValidation, setSubGroupValidation] = useState(false);
  const [selectGroupValidation, setSelectGroupValidation] = useState(false);
  const [groupValidation, setGroupValidation] = useState(false);
  const [groupTypeValidation, setGroupTypeValidation] = useState(false);

  const [modalDelete, setModalDelete] = useState(false);
  const [selectedLedger, setSelectedLedger] = useState(null);

  const [selectedSubGroup, setSelectedSubGroup] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [checkSearchTerm, setCheckSearchTerm] = useState(false);
  const [language, setLanguage] = useState("en");
  const [editMode, setEditMode] = useState(false);

  // ✅ Batch state — lifted here so AddSubGroup controls the full batch
  const [subGroupBatch, setSubGroupBatch] = useState([]);

  // Group modal batch (for CreateGroup inside SubGroup modal)
  const [groupBatch, setGroupBatch] = useState([]);

  const types = [{ name: "Stock", nameInHindi: "स्टॉक" }]

  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem("second_language"));
    if (stored?.language) setLanguage(stored.language);
  }, []);

  const {
    currentPage: currentPageSubGroups,
    itemsPerPage: itemsPerPageSubGroups,
    handlePageChange: handlePageChangeSubGroups,
    handleItemsPerPageChange: handleItemsPerPageChangeSubGroups,
    getPaginatedData: getPaginatedDataSubGroups,
  } = usePagination(10);

  const {
    currentPage: currentPageGroups,
    itemsPerPage: itemsPerPageGroups,
    handlePageChange: handlePageChangeGroups,
    handleItemsPerPageChange: handleItemsPerPageChangeGroups,
    getPaginatedData: getPaginatedDataGroups,
  } = usePagination(10);

  const paginationDataSubGroups = getPaginatedDataSubGroups(subGroups);
  const paginationDataGroups = getPaginatedDataGroups(groups);

  // ─── Fetch Groups ─────────────────────────────────────────────────────────
  useEffect(() => {
    if (branchId) fetchGroups();
  }, [currentPageGroups, itemsPerPageGroups, branchId]);

  const fetchGroups = async () => {
    try {
      const res = await api.get(`groups-types/get-all-group?branchId=${branchId}&type=Stock`);
      if (res.data.success) {
        const payload = res.data;
        const allData = Array.isArray(payload?.data)
          ? payload.data
          : Array.isArray(payload?.allData)
          ? payload.allData
          : [];
        const totalRecords = payload?.totalRecords ?? payload?.pagination?.totalRecords ?? allData.length;
        setGroups({ allData, pagination: { totalRecords } });
      }
    } catch (error) {
      console.error("Error fetching groups:", error);
      toast.error("Failed to load groups");
    }
  };

  // ─── Fetch SubGroups ──────────────────────────────────────────────────────
  useEffect(() => {
    if (branchId) fetchSubGroups();
  }, [currentPageSubGroups, itemsPerPageSubGroups, branchId]);

  const fetchSubGroups = async (
    page = currentPageSubGroups,
    limit = itemsPerPageSubGroups,
    search = ""
  ) => {
    try {
      setfetechDataLoading(true);
      const res = await api.get(
        `groups-types/get-all-sub-group?page=${page}&limit=${limit}&branchId=${branchId}&type=Stock&search=${encodeURIComponent(search)}`
      );
      if (res.data.success) {
        const payload = res.data;
        const allData = Array.isArray(payload?.data)
          ? payload.data
          : Array.isArray(payload?.allData)
          ? payload.allData
          : [];
        const totalRecords = payload?.totalRecords ?? payload?.pagination?.totalRecords ?? allData.length;
        const totalPages = Math.ceil(totalRecords / limit);
        const newPage = page > totalPages && totalPages > 0 ? totalPages : page;
        setSubGroups({ allData, pagination: { totalRecords } });
        if (newPage !== page) handlePageChangeSubGroups(newPage);
      }
    } catch (error) {
      console.error("Error fetching sub-groups:", error);
      toast.error("Failed to load sub-groups");
    } finally {
      setfetechDataLoading(false);
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    if (searchTerm.length === 0) setCheckSearchTerm(false);
  };

  useEffect(() => {
    if (checkSearchTerm && searchTerm.trim() === "") {
      fetchSubGroups();
    }
  }, [searchTerm]);

  // ─── Group Select ─────────────────────────────────────────────────────────
  const handleGroupSelect = (selectedGroupName) => {
    const selectedGroup = groups.allData.find((g) => g.groupName === selectedGroupName);
    if (selectedGroup) {
      const typeObj = types.find((t) => t.name === selectedGroup.type) || {
        name: selectedGroup.type,
        nameInHindi: "",
      };
      setGroupType(
        `${typeObj.name}${language !== "en" && typeObj.nameInHindi ? ` (${typeObj.nameInHindi})` : ""}`
      );
      setGroupId(selectedGroup.id || selectedGroup.group_id || selectedGroup.groupId || "");
      setGroupName(selectedGroup.groupName);
    } else {
      setGroupType("");
      setGroupId("");
      setGroupName("");
    }
  };

  // ─── Save SubGroup (single edit OR batch create) ──────────────────────────
  const handleSave = async () => {
    if (loading) return;

    // ─── EDIT MODE ────────────────────────────────────────────────────────
    if (isEditMode && selectedSubGroup?.id) {
      setLoading(true);
      try {
        const res = await api.post(
          `groups-types/update-sub-group?id=${selectedSubGroup.id}`,
          { subGroupName, subGroupNameInHindi, groupId, branchId }
        );
        if (res.data.success) {
          toast.success(res.data.message || "Sub-group updated!");
          fetchSubGroups();
          handleSubGroupCancel();
        } else {
          toast.error(res.data.message || "Update failed");
        }
      } catch (err) {
        console.error("Error updating sub-group:", err);
        toast.error(err?.response?.data?.message || "Error updating sub-group");
      } finally {
        setLoading(false);
      }
      return;
    }

    // ─── CREATE MODE: batch or single ────────────────────────────────────
    let finalBatch = [...subGroupBatch];

    if (subGroupName.trim() && groupId) {
      finalBatch.push({ subGroupName, subGroupNameInHindi, groupId, groupName, groupType });
    }

    if (finalBatch.length === 0) {
      toast.error("Please add at least one sub-group");
      return;
    }

    // Strip display-only fields before sending
    const cleanBatch = finalBatch.map(({ groupName: _gn, groupType: _gt, ...rest }) => rest);

    setLoading(true);
    try {
      const res = await api.post(`groups-types/new-sub-group`, {
        subGroups: cleanBatch,
        branchId,
      });
      if (res.data.success) {
        toast.success(
          res.data.message ||
            `${cleanBatch.length} sub-group${cleanBatch.length > 1 ? "s" : ""} added successfully!`
        );
        setSubGroupBatch([]);
        fetchSubGroups();
        handleSubGroupCancel();
      } else {
        toast.error(res.data.message || "Failed to save sub-groups");
      }
    } catch (err) {
      console.error("Error saving sub-groups:", err);
      toast.error(err?.response?.data?.message || "Error saving sub-groups");
    } finally {
      setLoading(false);
    }
  };

  // ─── Save Group (from nested modal) ──────────────────────────────────────
  const handleGroupSave = async () => {
    if (!groupName.trim()) { setGroupValidation(true); return; }
    if (!branchId) { toast.error("Missing branch!"); return; }
    if (!groupType) { setGroupTypeValidation(true); setGroupValidation(false); return; }

    setLoading(true);
    try {
      const response = await api.post(`groups-types/new-group`, {
        groupName,
        groupNameInHindi,
        type: groupType.name,
        typeInHindi: groupType.nameInHindi,
        branchId,
      });

      if (response.data?.success) {
        const newGroup = response.data.newData;
        // ✅ Immediately update local groups state so dropdown reflects new group instantly
        setGroups((prev) => ({
          allData: [...(prev?.allData ?? []), newGroup],
          pagination: { totalRecords: (prev?.pagination?.totalRecords ?? 0) + 1 },
        }));
        // ✅ Also auto-select the newly created group in the subgroup form
        const resolvedName = newGroup.groupName || newGroup.group_name || "";
        const resolvedId = newGroup.id || newGroup.group_id || newGroup.groupId || "";
        const resolvedType = newGroup.type || "";
        setGroupName(resolvedName);
        setGroupId(resolvedId);
        setGroupType(resolvedType);
        setGroupValidation(false);
        setGroupTypeValidation(false);
        setIsGroupModalOpen(false);
        setGroupBatch([]);
        // ✅ Also re-fetch from backend so data stays in sync
        fetchGroups();
        toast.success(response.data?.message || "Group added successfully");
      } else {
        toast.error(response.data?.message || "Failed to add group");
      }
    } catch (err) {
      console.error("Error adding group", err);
      toast.error("Failed to add group");
    } finally {
      setLoading(false);
    }
  };

  const handleGroupModelCancel = () => {
    setIsGroupModalOpen(false);
    setGroupTypeValidation(false);
    setGroupValidation(false);
    setGroupName("");
    setGroupNameInHindi("");
    setGroupId("");
    setGroupType("Assets");
    setGroupBatch([]);
  };

  const handleSubGroupCancel = () => {
    setIsModalOpen(false);
    setSelectedSubGroup(null);
    setIsEditMode(false);
    setSubGroupValidation(false);
    setSelectGroupValidation(false);
    setSubGroupName("");
    setSubGroupNameInHindi("");
    setGroupName("");
    setGroupId("");
    setGroupType("");
    setEditMode(false);
    setSubGroupBatch([]);
  };

  const handleAddSubGroup = () => {
    const trimmedValue = searchTerm.trim();
    if (trimmedValue.length > 0) {
      handlePageChangeSubGroups(1);
      fetchSubGroups(1, itemsPerPageSubGroups, trimmedValue);
      setCheckSearchTerm(true);
    } else {
      setIsEditMode(false);
      setSelectedSubGroup(null);
      setIsModalOpen(true);
      setCheckSearchTerm(false);
    }
  };

  const getSerialNumber = useCallback(
    (index) => (currentPageSubGroups - 1) * itemsPerPageSubGroups + index + 1,
    [currentPageSubGroups, itemsPerPageSubGroups]
  );

  const handleEditLedger = useCallback(
    (subGroup) => {
      setIsEditMode(true);
      setSelectedSubGroup(subGroup);
      setSubGroupName(subGroup.subGroupName);
      setSubGroupNameInHindi(subGroup.subGroupNameInHindi || "");
      setGroupName(subGroup.groupName);
      setGroupId(subGroup.groupId);
      setEditMode(true);
      const typeObj = types.find((t) => t.name === subGroup.type) || { name: subGroup.type, nameInHindi: "" };
      setGroupType(
        `${typeObj.name}${language !== "en" && typeObj.nameInHindi ? ` (${typeObj.nameInHindi})` : ""}`
      );
      setIsModalOpen(true);
    },
    [types, language]
  );

  const handleDeleteLedger = useCallback((ledger) => {
    setSelectedLedger(ledger);
    setModalDelete(true);
  }, []);

  const handleDeleteModalClose = useCallback(() => {
    setModalDelete(false);
    setSelectedLedger(null);
  }, []);

  return (
    <div className="py-2 flex justify-center">
      <div className="flex flex-col justify-center w-full">
        {/* Header */}
        <div className="flex justify-between py-[2px] items-center bg-theme-headerBg px-2 text-theme-color">
          <div className="font-medium">{t("subGroup")}</div>
          <div className="flex items-center gap-2">
            <input
              type="text"
              placeholder="Search group..."
              value={searchTerm}
              onChange={handleSearchChange}
              className="px-2 py-[2px] text-sm rounded-1 border border-gray-300 focus:outline-none text-black outline-none"
            />
            <AddButton
              onClick={handleAddSubGroup}
              text={searchTerm.trim() ? "Search" : t("add")}
            />
          </div>
        </div>

        {fetchDataLoading ? (
          <div className="flex justify-center my-4">
            <LoadingSpinner size={70} color="#be8024" />
          </div>
        ) : (subGroups?.pagination?.totalRecords ?? 0) === 0 ? (
          <p className="text-gray-500 italic text-sm text-center mt-5 pt-3">
            {t("noDataAvailable")}
          </p>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full border-separate border-spacing-0 rounded text-sm mb-20">
              <thead>
                <tr className="bg-theme-tableBg text-theme-headerBg border-theme-headerBg">
                  <th className="border-b px-1 text-center font-medium">{t("srNumber")}</th>
                  <th className="border-b py-[2px] px-1 text-left font-medium">{t("subGroupName")}</th>
                  <th className="border-b px-1 text-left font-medium">{t("groupName")}</th>
                  <th className="border-b px-1 text-left font-medium">{t("type")}</th>
                  <th className="border-b px-1 text-center font-medium">{t("action")}</th>
                </tr>
              </thead>
              <tbody>
                {paginationDataSubGroups.currentItems?.map((g, index) => (
                  <tr key={g.id} className="bg-theme-tableBg hover:bg-theme-tableHoverColor">
                    <td className="border-b px-1 text-center">{getSerialNumber(index)}</td>
                    <td className="border-b py-[2px] px-1 capitalize">
                      {g.subGroupName}{" "}
                      {language !== "en" && g.subGroupNameInHindi && `( ${g.subGroupNameInHindi} )`}
                    </td>
                    <td className="border-b px-1">
                      {g.groupName}{" "}
                      {language !== "en" && g.groupNameInHindi && `( ${g.groupNameInHindi} )`}
                    </td>
                    <td className="border-b px-1">
                      {g.type} {language !== "en" && g.typeInHindi && `( ${g.typeInHindi} )`}
                    </td>
                    <td className="border-b px-1">
                      <div className="flex justify-center gap-2">
                        <FaEdit
                          className={
                            g.branch_id !== 0
                              ? "text-gray-700 mt-1 cursor-pointer hover:text-theme-btnBg transition-colors"
                              : "text-gray-400 mt-1 opacity-50 pointer-events-none"
                          }
                          onClick={g.branch_id !== 0 ? () => handleEditLedger(g) : undefined}
                          title="Edit sub-group"
                        />
                        <RiDeleteBin6Fill
                          title="Delete sub-group"
                          onClick={g.branch_id !== 0 ? () => handleDeleteLedger(g) : undefined}
                          className={
                            g.branch_id !== 0
                              ? "text-red-700 mt-1 cursor-pointer hover:text-red-800 transition-colors"
                              : "text-red-400 mt-1 opacity-50 pointer-events-none"
                          }
                        />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <Pagination
              data={subGroups}
              currentPage={currentPageSubGroups}
              itemsPerPage={itemsPerPageSubGroups}
              onPageChange={handlePageChangeSubGroups}
              onItemsPerPageChange={handleItemsPerPageChangeSubGroups}
              itemsPerPageOptions={[10, 20, 50, 100]}
              showItemsPerPageSelector={true}
              showPageInfo={true}
              position="bottom-center"
            />
          </div>
        )}
      </div>

      {/* ✅ SubGroup Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 flex justify-center items-center bg-black/20 z-[1100]">
          <CreateSubGroup
            subGroupName={subGroupName}
            subGroupNameInHindi={subGroupNameInHindi}
            setSubGroupNameInHindi={setSubGroupNameInHindi}
            setSubGroupName={setSubGroupName}
            subGroupValidation={subGroupValidation}
            groupName={groupName}
            setGroupName={setGroupName}
            groupId={groupId}
            setGroupId={setGroupId}
            selectGroupValidation={selectGroupValidation}
            groupType={groupType}
            setGroupType={setGroupType}
            setIsGroupModalOpen={setIsGroupModalOpen}
            handleGroupSelect={handleGroupSelect}
            handleSubGroupCancel={handleSubGroupCancel}
            handleSave={handleSave}
            loading={loading}
            allGroupsData={groups.allData}
            selectedSubGroup={selectedSubGroup}
            setSubGroupValidation={setSubGroupValidation}
            setSelectGroupValidation={setSelectGroupValidation}
            addMoreButton={true}    // ✅ show Add More
            isEditMode={isEditMode}
            // ✅ batch state
            subGroupBatch={subGroupBatch}
            setSubGroupBatch={setSubGroupBatch}
          />
        </div>
      )}

      {/* Group Modal (nested inside SubGroup flow) */}
      {isGroupModalOpen && (
        <div className="fixed inset-0 flex justify-center items-center bg-black/15 z-[1100]">
          <CreateGroup
            groupName={groupName}
            setGroupName={setGroupName}
            groupNameInHindi={groupNameInHindi}
            setGroupNameInHindi={setGroupNameInHindi}
            groupValidation={groupValidation}
            groupType={groupType}
            setGroupType={setGroupType}
            groupTypeValidation={groupTypeValidation}
            setGroupTypeValidation={setGroupTypeValidation}
            types={types}
            handleCancel={handleGroupModelCancel}
            handleSave={handleGroupSave}
            setGroupValidation={setGroupValidation}
            addMoreButton={false}   // no add-more inside nested group modal
            loading={loading}
            setLoading={setLoading}
            groupBatch={groupBatch}
            setGroupBatch={setGroupBatch}
          />
        </div>
      )}

      {/* Delete Modal */}
      {modalDelete && (
        <DeleteDataModal
          selectedLedger={selectedLedger}
          handleDeleteModalClose={handleDeleteModalClose}
          handleDeleteLedgerApi={async (ledger) => {
            try {
              const res = await api.post(`groups-types/delete-sub-group?id=${ledger.id}`, {
                isDelete: 1,
                branchId,
              });
              if (res.data.success) {
                toast.success(res.data.message || "Sub-group deleted successfully");
                fetchSubGroups();
              } else {
                toast.error(res.data.message || "Failed to delete sub-group");
              }
            } catch (err) {
              console.error("Error deleting sub-group", err);
              toast.error(err?.response?.data?.message || "error deleting sub-group");
            } finally {
              handleDeleteModalClose();
            }
          }}
        />
      )}
    </div>
  );
}